import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Alert } from 'foundations-library/components'

const jss = (theme) => {
    return {
        alert: {
            justifyContent: 'center',
            width: '75%',
            margin: '0 auto 20px',
            boxSizing: 'border-box',
            [theme.breakpoints.down('xs')]: {
                width: '100%',
                maxWidth: '400px'
            }
        }
    }
}

const useStyles = makeStyles(jss)

/**
 *
 */
const PasswordExpiry = ({ date }: { date: string }) => {
    const classes = useStyles()

    return (
        <Alert
            level='error'
            icon='alert'
            className={classes.alert}
        >
            Your password is expiring soon! For your protection, please create a new password before {new Date(date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}.
        </Alert>
    )
}

export default PasswordExpiry
